<template>
  <div class="sandbox">
    <Blockly/>
    <transition name="slide-top">
      <div class="info-bar-wrapper"
           :class="{'highlight-element': !isInfoOpen && !userDataStore.isTutorialShown}"
           v-if="!isInfoOpen"
           @click="openInfo"
      >
        <div class="info-bar-content">
          <span>Menu</span>
          <i class="fas fa-angle-down text-hint-icon"/>
        </div>
      </div>
    </transition>
    <div class="info-wrapper" ref="info" :class="{'closed': !isInfoOpen}" @click="close">
      <div class="grid-container text-content" @click="isClickingModal = true">
        <div class="info-metadata">
          <b>Sandbox Menu</b>
        </div>
        <hr>
        <div>
          <h3>Blok tersimpan</h3>
          <div class="blank-item" v-for="a in 3" :key="a"></div>
          <button class="btn btn--tab mb-1 btn--disabled"><i class="fas fa-save mr-1"></i> Simpan blok dari kanvas</button>
          <button class="btn btn--tab mb-1 btn--disabled"><i class="fas fa-arrow-right mr-1"></i>Muat blok ke kanvas</button>
        </div>
        <hr>
        <div class="flex flex-spaced mt-1">
          <router-link :to="{ name: 'home' }" class="btn btn--tab btn--red"><i class="fas fa-arrow-left mr-1"></i>Kembali ke menu utama</router-link>
          <button class="btn btn--tab" @click="close"><i class="fas fa-times mr-1"></i>Tutup menu</button>
        </div>
      </div>
    </div>
    <transition name="scale-out-ease">
      <div class="hint-section"
           v-if="!isInfoOpen && !userDataStore.isTutorialShown"
           @click="userDataStore.isTutorialShown = true"
      >
        <div class="hint-text">
          <div>
            <i class="fas fa-arrow-up"/>
          </div>
          Klik di sini untuk mengakses menu!<br><br><br>
          <b>Klik di mana saja untuk melanjutkan</b>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Blockly from '@/components/Blockly'

  export default {
    name: 'sandbox',
    components: {
      Blockly
    },
    data() {
      return {
        isInfoOpen: false,
        isClickingModal: true,
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
    },
    methods: {
      openInfo() {
        this.isInfoOpen = true
        this.$refs.info.scrollTop = 0
      },
      close() {
        if (this.isClickingModal)
          this.isClickingModal = false
        else
          this.isInfoOpen = false
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";

  .sandbox {
    height: 100vh;
  }

  .info-bar-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    display: flex;
    pointer-events: none;
  }

  .info-bar-content {
    margin: auto;
    background-color: white;
    box-shadow: 0 5px 10px 0 rgba(black, 0.1);
    padding: 0.25rem 1rem;
    border-radius: 0 0 10px 10px;
    pointer-events: auto;
    cursor: pointer;
    font-weight: 500;
  }

  .text-hint-icon {
    margin: 0 0.25rem;
  }

  .info-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(black, 0.3);
    z-index: 100;
    display: flex;
    padding: 0 1rem 2rem 1rem;
    overflow-y: auto;
    box-sizing: border-box;
    transition: background-color 0.8s 0.1s;
  }

  .text-content {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: auto;
    padding: 1rem;
    background-color: white;
    border-radius: 0 0 10px 10px;
    max-width: 800px;
    box-shadow: 0 10px 10px 0 rgba(black, 0.2);
    transition: all 0.2s ease-out;
  }

  .info-metadata {
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-weight: 900;
      font-size: 1.5rem;
      background: linear-gradient(to bottom right, #116e76, #001011);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      background: linear-gradient(to bottom right, #116e76, #001011);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: end;
    }
  }

  .info-wrapper.closed {
    background-color: rgba(black, 0);
    overflow-y: hidden;
    pointer-events: none;
    transition: background-color 0.3s;

    .text-content {
      transform: translateY(calc(-50px));
      opacity: 0;
      transition: all 0.2s ease-in;
    }
  }

  .blank-item {
    margin: 0.5rem;
    flex-basis: 30%;
    text-align: center;
    background-color: rgba(black, 0.05);
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 10px;
    height: 100px;
  }

  .dark-mode {
    .start-screen::before, .end-screen::before {
      background-color: rgba($dark-mode-back-primary, 0.85);
    }

    .info-bar-content, .text-content, .end-stats {
      background-color: $dark-mode-back-secondary;
    }

    .info-metadata b, .info-metadata p, .end-header, .anim-1 {
      filter: brightness(2.5);
    }
  }
</style>
